import React from 'react'

import Card from '../../../../../1stlog-ui/src/components/Card'

export interface IOrderEntryCardProps {
  isCompact?: boolean
  withoutCard?: boolean
  title?: string
  children: React.ReactNode
}

const OrderEntryCard = (props: IOrderEntryCardProps): React.ReactElement => {
  const { children, withoutCard, title, isCompact } = props
  const wrapper = withoutCard ? (
    <></>
  ) : (
    <Card
      title={title}
      withHeaderBorder={isCompact}
      withoutRadius={isCompact}
    ></Card>
  )

  return React.cloneElement(wrapper, {
    children,
  })
}

export default OrderEntryCard
